import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {MemberService} from "../../service/member/member.service";
import {MemberPage, MemberTeamPage} from "../../service/member/member";

@Component({
  selector: 'app-space-members',
  templateUrl: './members.component.html',
  styleUrls: ['./members.component.scss'],
  providers: [MemberService]
})
export class SpaceMembersComponent implements OnInit {
  teams: MemberTeamPage;

  constructor(private memberService: MemberService,
              private route: ActivatedRoute,
              private router: Router) {
  }

  ngOnInit() {

    this.route.queryParams.subscribe(
      params => {
        this.page     = params['page']       ? +params['page']     : 1;
        this.search   = params['search']    ? params['search']   : '';
        this.location = params['location']  ? params['location'] : this.router.url.split('/')[1];
        // console.log(this.location)

        this.getTeams();
      }
    )
  }

  getTeams() {
    this.memberService.getTeams(this.page, this.location, this.search).subscribe(
      teams => this.teams = teams
    );
  }

  reload() {
    let url = this.router.url.split('?')[0];
    this.router.navigateByUrl(
      `${url}?` +
      (this.page ? `page=${this.page}` : '') +
      `${this.location ? `&location=${this.location}` : ''}` +
      `${this.search   ? `&search=${this.search}`   : ''}`
    );
  }

  search: string = '';
  onSearch(term: string) {
    this.search = term;
    this.reload();
  }

  location: string;
  onLocation(location: string) {
    this.location = location;
    this.reload();
  }

  page: number = 1;
  onPageChanged(event: any) {
    if (event.page == this.page) return;
    this.page = event.page;
    this.reload();
  }
}



// WEBPACK FOOTER //
// ./src/app/space/members/members.component.ts